const state = {
  cikkcsoports: undefined,
};

export default state;
